
import { Component, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RadioListImage } from 'app/components/shared/bb-radio-list/bb-radio-list.component';
import { ChannelBlock, ChannelBlockPlayerLayout, ChannelBlockType } from 'app/interfaces/channel';
import { Subject } from 'rxjs';

import { PORTAL_DATA } from '../../../services/overlay.service';

interface addElementData {
	// the element Name, or null (close with <x> (value = null) is also passed to this subject)
	elementChosenSubject: Subject<ChannelBlockPlayerLayout | ChannelBlockType | null>;
	currentBlocks: ChannelBlock<ChannelBlockType>[];
}

@Component({
	selector: 'channel-details-add-element',
	templateUrl: './channel-details-add-element.component.html',
	styleUrls: ['./channel-details-add-element.component.scss']
})
export class ChannelDetailsAddElementComponent {
	element: ChannelBlockPlayerLayout | ChannelBlockType | null;

	headerOptions: RadioListImage[];
	playerOptions: RadioListImage[];
	playlistOptions: RadioListImage[];
	featuredOptions: RadioListImage[];

	elementItems: { label: string; options: RadioListImage[]; warning?: string }[];

	constructor(
		@Inject(PORTAL_DATA) public data: addElementData,
		private translate: TranslateService
	) {
		const headerInUse = this.data.currentBlocks.some(b => ['HeaderLogoTitle', 'FeaturedHeader'].includes(b.type));
		const playerInUse = this.data.currentBlocks.some(b => b.type === 'Player');

		this.headerOptions = [
			{ label: this.translate.instant('LOGOTITLE'), value: 'HeaderLogoTitle', imageUrl: '/resources/img/channels/Header-logo-title.svg', disabled: headerInUse },
			{ label: this.translate.instant('FEATURED_HEADER'), value: 'FeaturedHeader', imageUrl: '/resources/img/channels/Featured-header.svg', disabled: headerInUse }
		];

		this.playerOptions = [
			{ label: this.translate.instant('PLAYER_SINGLE'), value: 'single', imageUrl: '/resources/img/channels/Single-player.svg', disabled: playerInUse },
			{ label: this.translate.instant('PLAYLIST_RIGHT'), value: 'right', imageUrl: '/resources/img/channels/With-playlist.svg', disabled: playerInUse },
			{ label: this.translate.instant('PLAYLIST_BELOW'), value: 'below', imageUrl: '/resources/img/channels/Playlist-below.svg', disabled: playerInUse }
		];

		this.playlistOptions = [
			{ label: this.translate.instant('SLIDER'), value: 'Cliplist', imageUrl: '/resources/img/channels/Ending-slider.svg' },
			{ label: this.translate.instant('CAROUSEL'), value: 'Carousel', imageUrl: '/resources/img/channels/Carousel.svg' },
			{ label: this.translate.instant('GRID'), value: 'Grid', imageUrl: '/resources/img/channels/Grid.svg' }
		];

		this.featuredOptions = [
			{ label: this.translate.instant('FEATURED'), value: 'Featured', imageUrl: '/resources/img/channels/Featured.svg' },
			{ label: this.translate.instant('PROMOTIONAL'), value: 'Promotional', imageUrl: '/resources/img/channels/PromoLarge.svg' }
		];

		this.elementItems = [
			{ label: 'HEADER', options: this.headerOptions, warning: headerInUse ? 'CHANNEL_MAX_1_HEADER' : '' },
			{ label: 'VIDEOPLAYER', options: this.playerOptions,  warning: playerInUse ? 'CHANNEL_MAX_1_PLAYER' : ''  },
			{ label: 'PLAYLIST', options: this.playlistOptions },
			{ label: 'FEATURED', options: this.featuredOptions },
		];
	}

	elementChosen(value: ChannelBlockPlayerLayout | ChannelBlockType): void {
		this.data.elementChosenSubject.next(value);
	}

	close() {
		// close by using <X> button
		this.data.elementChosenSubject.next(null);
	}
}
